import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_TICKET } from "../actions/Ticket/actionTypes";
import {
  getListTicketSuccess,
  getListTicketFailure,
} from "../actions/Ticket";
import TicketApi from "service/ticketApi";


function* getListTicket(action) {
  try {
    const response = yield call(TicketApi.list, action.dataSearch);
    console.log(response.data.Result,'list');
    if (response.ok) {
      yield put(getListTicketSuccess(response.data.Result));
    } else {
      yield put(getListTicketFailure());
    }
  } catch (error) {
    yield put(getListTicketFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_TICKET, getListTicket);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
